const headerSubTitleActions = {
    updateSubTitle: (draft, {subTitle, iconUrl}) => {
        draft.subTitle = subTitle;
        draft.iconUrl = iconUrl;
    },

    clearSubTitle: draft => {
        draft.subTitle = null;
        draft.iconUrl = null;
    },
};

export default headerSubTitleActions;
